import React from "react";
import { Cell, Column } from "react-table";
import { Text } from "@chakra-ui/react";
import { lowerCase, startCase, upperFirst } from "lodash";
import { sortBy } from "lodash";

import { Table } from "@alpacahq/alpaca-component-library";

import { AcatsAsset, useAcatsAssets } from "../../../api/acats/listAcatsAssets";
import Card from "../../../components/general/Card";
import { cashFormat, fmtCellValue, toStartCase } from "../../../globals/utils";

interface AcatsAssetsProps {
  accountID: string;
  acatsID: string;
}

const columns: Column<AcatsAsset>[] = [
  {
    id: "isin",
    accessor: "isin",
    Header: "ISIN",
    Cell: ({ value }: Cell<AcatsAsset>) => fmtCellValue(value),
  },
  {
    id: "asset_class",
    accessor: "asset_class",
    Header: "Asset Class",
    Cell: ({ value }: Cell<AcatsAsset>) =>
      fmtCellValue(startCase(lowerCase(value))),
  },
  {
    id: "asset_description",
    accessor: "asset_description",
    Header: "Name",
    Cell: ({ value }: Cell<AcatsAsset>) => fmtCellValue(value),
  },
  {
    id: "quantity",
    accessor: "quantity",
    Header: "Shares",
    Cell: ({ value }: Cell<AcatsAsset>) => fmtCellValue(value),
  },
  {
    id: "currency_code",
    accessor: "currency_code",
    Header: "Currency",
    Cell: ({ value }: Cell<AcatsAsset>) => fmtCellValue(value),
  },
  {
    id: "amount",
    accessor: "amount",
    Header: "Market Value",
    Cell: ({ value }: Cell<AcatsAsset>) => cashFormat(value),
  },
  {
    id: "position",
    accessor: "position",
    Header: "Position",
    Cell: ({ value }: Cell<AcatsAsset>) => toStartCase(lowerCase(value)),
  },
  {
    id: "status",
    accessor: "status",
    Header: "Status",
    Cell: ({ value }: Cell<AcatsAsset>) => toStartCase(lowerCase(value)),
  },
  {
    id: "rejection_message",
    accessor: "rejection_message",
    Header: "Rejection Message",
    Cell: ({ value }: Cell<AcatsAsset>) => fmtCellValue(upperFirst(value)),
  },
];

const AcatsAssets = ({ accountID, acatsID }: AcatsAssetsProps): JSX.Element => {
  const { data, isLoading } = useAcatsAssets(accountID, acatsID);
  const assets = sortBy(data, (asset) => asset.asset_description) ?? [];

  return (
    <Card p="1rem 1.25rem" position="relative">
      <Text fontSize="lg" fontWeight={500} py="14.5px" position="absolute">
        Assets
      </Text>
      <Table
        mt={assets.length === 0 ? "56px" : undefined}
        columns={columns}
        data={assets}
        defaultPerPage={20}
        isLoading={isLoading}
        pagination
        paginationPosition="top"
      />
    </Card>
  );
};

export default AcatsAssets;
